export const downloadFile = (blob: Blob, filename: string) => {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    anchor.style.visibility = 'hidden';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
};

export const downloadFromUrl = async (
    url: string,
    filename: string,
    headers: HeadersInit = {},
) => {
    const response = await fetch(url, { headers });
    if (!response.ok) {
        throw new Error(
            `Download failed: ${response.status} ${response.statusText}`,
        );
    }
    const blob = await response.blob();
    downloadFile(blob, filename);
};
